module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "CMIP-winter-median.7ce8c89e.jpeg";